import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.webysee.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 secondes timeout
});

// Intercepteur pour ajouter le token JWT à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Erreur API:', error.response?.data || error.message);

    // Erreur de connexion au serveur
    if (!error.response) {
      console.error('Impossible de contacter le serveur');
      // Ne pas déconnecter, juste retourner l'erreur
      return Promise.reject({
        response: {
          data: {
            message: 'Impossible de contacter le serveur. Vérifiez votre connexion.',
            code: 'NETWORK_ERROR'
          }
        }
      });
    }

    // Token expiré ou invalide
    if (error.response?.status === 401) {
      const errorCode = error.response?.data?.code;
      
      // Déconnecter uniquement si vraiment nécessaire
      if (errorCode === 'TOKEN_EXPIRED' || errorCode === 'INVALID_TOKEN' || errorCode === 'INVALID_USER') {
        console.log('Session expirée, déconnexion...');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Rediriger vers login seulement si on n'y est pas déjà
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;